export enum ThunkResolvedStatus {
  requested = "requested",
  pending = "pending",
  idle = "idle",
  fulfilled = "succeeded",
  rejected = "failed",
  error = "error",
}
